import { render, staticRenderFns } from "./configured-fields.vue?vue&type=template&id=6f242cb0&scoped=true&"
import script from "./configured-fields.vue?vue&type=script&lang=js&"
export * from "./configured-fields.vue?vue&type=script&lang=js&"
import style0 from "./configured-fields.vue?vue&type=style&index=0&id=6f242cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f242cb0",
  null
  
)

component.options.__file = "configured-fields.vue"
export default component.exports